<template>
	<div>
		<sf-search-layout>
			<el-row :gutter="3">
				<el-col :span="8">
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						:clearable="false"
						@commInput="setText"
						:propData="searchPopupMParams.partNo"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button style="width: 110px" line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="searchPopupMList">{{
					getButtonMsg_(scrId, 'CR')
				}}</sf-button>
			</template>
		</sf-search-layout>
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
	</div>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PartCkuPrvs/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import SearchInput from '@qms/Components/SearchInput';
import partMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchInput,
		partMngPopup
	},
	data() {
		return {
			// partNo: ''
		};
	},
	async created() {
		// console.log('propData >>>', this.propData);
	},
	methods: {
		...serviceMethods,
		...rootMethods,
		// setSearchParam({ key, value }) {
		// 	this.[key] = value;
		// },
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchPopupMParams.partNo);
		},
		sendData(param) {
			this.setSearchPopupMParam_({ key: 'partNo', value: param.partNo });
		},
		async searchPopupMList() {
			//console.log('확인');
			try {
				// let sPartNo = this.searchPopupMParams.partNo;
				// console.log(sPartNo);
				// if (sPartNo === '') {
				// 	throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001754'))); // 조회조건의 부품번호를 입력해 주시기 바랍니다.
				// }

				this.$sf_toggleLoading(true);
				this.setPopupDataMstListInit();
				await this.getPopupMList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message || error
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		setText(param) {
			this.setSearchPopupMParam_(param);
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style></style>
